<template>
    <div class="jurisdiction">
        <Spin size="large" fix v-if="spinShow"></Spin>
        <customButton :button-config="buttonConfig"/>
        <div class="content">
            <div class="FilterTree_box left_col">
                <FilterTree
                        class="FilterTree"
                        :treeAttribute="filterTreeConfig.treeAttribute"
                        :treeEvent="filterTreeConfig.treeEvent"
                        :clearable="filterTreeConfig.clearable"
                        :placeholder="filterTreeConfig.placeholder"
                ></FilterTree>
            </div>
            <div class="right_col">
                <div class="SearchForm_Table">
                    <div class="fromHeight" v-if="permissionType !== 'sensitive'">
                        <SearchForm
                                class="SearchForm"
                                :setHeight="searchFormConfig.setHeight"
                                :rowAll="searchFormConfig.rowAll"
                                :searchFoldnum="searchFormConfig.searchFoldnum"
                                :defaultColumn="searchFormConfig.defaultColumn"
                                :defaultconfig="searchFormConfig.defaultconfig"
                        ></SearchForm>
                        <customButton :button-config="searchBtnConfig"/>
                    </div>
                    <div class="table_content">
                        <quanXianTable
                                ref="quanXianTable"
                                :searchValue="tableArr.searchValue"
                                :rows="tableArr.rows"
                                :columns="tableArr.columns"
                                :tableArr="tableArr"
                                @isChangeFun="isChangeFun"
                        ></quanXianTable>
                    </div>
                </div>
            </div>
        </div>
        <copyModal :copyModal="copyModal" @cancel-btn="cancelBtn" @sure-btn="sureBtn"></copyModal>
        <Modal v-model="saveModal" title="提示" @on-ok="saveOk" @on-cancel="saveCancel">
            <p>是否保存已经修改的数据?</p>
        </Modal>
    </div>
</template>
<script>
    import qxBtnData from "./qxBtnData";
    import customButton from "./customButton";
    import quanXianTable from "./quanXianTable";
    import copyModal from "./copyModal";
    // import R3 from '@syman/burgeon-r3'
    const {FilterTree, SelectTree, SearchForm} = R3.default.components;
    import axios from "axios";
    import form from "@/__utils__/form";

    export default {
        components: {
            customButton,
            quanXianTable,
            FilterTree,
            SelectTree,
            SearchForm,
            copyModal
        },
        mixins: [qxBtnData],
        data() {
            return {
                spinShow: false,
                saveModal: false,
                changeData: [],
                permissionType: '', //权限类型
                permissionTable: '',
                permissionKeyColumn: '',

                groupId: '', // 菜单id
                newGroupId: '', // 切换菜单时，当前切换的id

                isChange: false,

                searchFormConfig: {
                    setHeight: 34,
                    rowAll: 3,
                    searchFoldnum: 2,
                    defaultColumn: 3,
                    defaultconfig: []
                },

                copyModal: false, // 弹框
                buttonConfig: {
                    buttons: []
                },

                searchBtnConfig: {
                    flex: "right",
                    buttons: [
                        {
                            text: "搜索",
                            icon: "",
                            btnClick: () => {
                                let self = this;
                                let obj = {};
                                console.log(self.searchFormConfig.defaultconfig);
                                self.searchFormConfig.defaultconfig.map(item => {
                                    if (item.item.value) {
                                        obj[item.item.field] = item.item.value;
                                    }
                                });
                                self.getTableData(obj);
                            }
                        }
                    ]
                },

                filterTreeConfig: {
                    treeAttribute: {
                        data: []
                    },
                    treeEvent: {
                        "on-select-change": this.filterTreeChange
                    },
                    clearable: true,
                    placeholder: "请输入"
                },

                oldTableArr: [],
                saveTableArr: [],

                tableArr: {
                    searchValue: "", //检索的输入框
                    columns: [],
                    rows: [],
                    isReadValueTotal: 0,
                    isWriteValueTotal: 0,
                    isReadValue: false,
                    isWriteValue: false,
                    isChild: false,
                    parentIsRead: 0,
                    parentIsWrite: 0,
                    isParentReadValue: false,
                    isParentWriteValue: false
                },
                sensitiveColumns: [
                    {
                        title: '敏感列',
                        key: 'CP_C_COLUMN_ENAME'
                    },
                    {
                        title: '查看',
                        key: 'IS_READ'
                    },
                    {
                        title: '编辑',
                        key: 'IS_WRITE'
                    }
                ],
            };
        },

        created() {
            const {customizedModuleName, customizedModuleId} = this.$route.params;
            this.permissionType = this.$route.query.type;

            // 获取角色
            this.getRoleData();
            if (this.permissionType !== 'sensitive') {
                this.getSearchForm();
            }
            this.buttonConfig.buttons = this.normal.buttons;
        },
        mounted() {
            const {customizedModuleName} = this.$route.params;

        },
        methods: {
            saveOk() {
                this.saveQuanXian();
            },
            saveCancel() {
                if (this.newGroupId !== this.groupId) {
                    this.isChange = false;
                    this.getTableData();
                }
            },
            isChangeFun(val, row) {
                console.log(row);
                this.isChange = val;
                let totalData = [];
                let isExit=false; // 判断是否存在
                if (Array.isArray(row)) {
                    this.changeData = row
                } else {
                    if (this.changeData.length != 0) {
                        this.changeData.map(
                            item => {
                                if (this.permissionKeyColumn){
                                    if (item[this.permissionKeyColumn] == row[this.permissionKeyColumn]) {
                                        isExit=true;
                                        item = row;
                                    }
                                }else {
                                    if (item['ID'] == row['ID']) {
                                        isExit=true;
                                        item = row;
                                    }
                                }

                            }
                        );
                        if (!isExit){
                            totalData.push(row)
                        }
                    } else {
                        totalData.push(row)
                    }
                    this.changeData = [...this.changeData, ...totalData]
                }
            },
            filterTreeChange(val, item) {
                this.newGroupId = item.ID;
                if (this.isChange) {
                    this.saveModal = true;
                } else {
                    // this.saveCancel();
                }
                // 清空刷选数据
                this.tableArr.columns=[];
                this.tableArr.rows=[];
                this.changeData=[];
            },
            restructureMenuTreeData(data, first) {
                return data.map((item, idx) => {
                    item.title = item.NAME;
                    if (first && idx === 0) {
                        item.selected = true;
                    }
                    if (item.children && item.children.length > 0) {
                        this.restructureMenuTreeData(item.children);
                    }
                    return item;
                });
            }, // 重构树数据

            // 获取角色id
            getRoleData() {
                this.$network.post('/p/cs/groupTreeload', {})
                    .then((res) => {
                        if (res.data.code === 0) {
                            this.groupId = res.data.data[0].ID;
                            this.newGroupId = res.data.data[0].ID;
                            this.filterTreeConfig.treeAttribute.data = this.restructureMenuTreeData(res.data.data, true);

                            // this.getTableData();  // 取消右测表格默认查询
                        }
                    });
            },
            // 获取搜索框
            getSearchForm() {
                this.$network.post('/p/cs/permission/v1/selectPermissionColumn', this.$urlSearchParams({permissionType: this.permissionType}))
                    .then((res) => {
                        if (res.data.code === 0) {
                            let moreSelect=	{
                                "coldesc":"产品中类",
                                "colname":"BIGCATE",
                                "isuppercase":false,
                                "display":"OBJ_FK",
                                "webconf":null,
                                "colid":1700810335,
                                "inputname":"BIGCATE:ENAME",
                                "fkobj":{
                                    "reftable":"PS_C_PRODIM_ITEM",
                                    "fkdisplay":"mrp",
                                    "reftableid":23156,
                                    "url":"",
                                    "option":null,
                                    "searchmodel":"mop"
                                }
                            };
                            // res.data.datas.dataarry.unshift(moreSelect);
                            let dataArray = form.refactoringData(res.data.datas.dataarry);
                            dataArray.map(item => {
                                if (item.item.value) {
                                    item.item.props.value = item.item.value;
                                }
                            })
                            console.log(dataArray)
                            this.searchFormConfig.defaultconfig = dataArray;
                        }
                    });
            },

            // 获取表格
            getTableData(searchCondition = {}, refresh = false) {
                this.groupId = this.newGroupId;
                let url, params;
                if (this.permissionType === "sensitive") {
                    url = '/p/cs/cgroupcolumnquery';
                    params = {
                        GROUPS_ID: this.groupId,
                        QUERY: ""
                    };
                } else {
                    url = '/p/cs/permission/v1/selectDataPermission';
                    params = {
                        permissionType: this.permissionType,
                        groupId: this.groupId,
                        searchCondition: searchCondition
                    };
                }
                this.$network.post(url, this.$urlSearchParams(params))
                    .then((res) => {
                        if (res.data.code === 0) {
                            this.tableArr.isReadValueTotal = 0;
                            this.tableArr.isWriteValueTotal = 0;
                            this.tableArr.isReadValue = false;
                            this.tableArr.isWriteValue = false;
                            this.tableArr.isChild = false;
                            this.tableArr.parentIsRead = 0;
                            this.tableArr.parentIsWrite = 0;
                            this.tableArr.isParentReadValue = false;
                            this.tableArr.isParentWriteValue = false;

                            if (this.permissionType === "sensitive") {
                                let dt = res.data.data;
                                dt.map((item) => {
                                    dt.isChild = !!item.PARENT_GROUPS_ID;
                                    if (item.PARENT_GROUPS_ID) {
                                        if (item.PARENT_ISREAD == 'Y') {
                                            this.tableArr.parentIsRead++;
                                        }
                                        if (item.PARENT_ISMODIFY == 'Y') {
                                            this.tableArr.parentIsWrite++;
                                        }
                                    }
                                    item.IS_WRITE = item.ISMODIFY == 'Y';
                                    item.IS_READ = item.ISREAD == 'Y';
                                });
                                this.tableArr.columns = this.sensitiveColumns;
                                this.tableArr.rows = res.data.data;
                                this.tableArr.isChild = dt.isChild;
                            } else {
                                let dt = res.data.data;
                                dt.rows.map(item => {
                                    dt.isChild = !!item.PARENT_GROUPS_ID;
                                    if (item.PARENT_GROUPS_ID) {
                                        if (item.PARENT_IS_READ == 'Y') {
                                            this.tableArr.parentIsRead++;
                                        }
                                        if (item.PARENT_IS_WRITE == 'Y') {
                                            this.tableArr.parentIsWrite++;
                                        }
                                    }
                                })
                                this.tableArr.columns = dt.columns;
                                this.tableArr.rows = dt.rows;
                                this.tableArr.isChild = dt.isChild;
                            }

                            this.tableArr.rows.forEach(item => {
                                if (item.IS_READ === "Y" || item.ISREAD === "Y") {
                                    item.IS_READ = true;
                                    this.tableArr.isReadValueTotal++;
                                } else {
                                    item.IS_READ = false;
                                }
                                if (item.IS_WRITE === "Y" || item.ISMODIFY === "Y") {
                                    item.IS_WRITE = true;
                                    this.tableArr.isWriteValueTotal++;
                                } else {
                                    item.IS_WRITE = false;
                                }
                            });

                            if (this.tableArr.parentIsRead === this.tableArr.rows.length) {
                                this.tableArr.isParentReadValue = true;
                            }
                            if (this.tableArr.parentIsWrite === this.tableArr.rows.length) {
                                this.tableArr.isParentWriteValue = true;
                            }
                            if (this.tableArr.isReadValueTotal === this.tableArr.rows.length) {
                                this.tableArr.isReadValue = true;
                            }
                            if (this.tableArr.isWriteValueTotal === this.tableArr.rows.length) {
                                this.tableArr.isWriteValue = true;
                            }

                            this.permissionTable = res.data.data.permissionTable;
                            this.permissionKeyColumn = res.data.data.permissionKeyColumn;

                            this.oldTableArr = JSON.parse(JSON.stringify(this.tableArr.rows));
                            if (refresh) {
                                this.$Message.success('刷新成功');
                            }
                        }
                    });
            },

            sureBtn(params) {
                this.copyModal = false;
                let param = new URLSearchParams();
                console.log(params);
                param.append("param", JSON.stringify(params));
                axios({
                    url: "/p/cs/copyShopPermission",
                    method: "post",
                    data: param
                }).then(res => {
                    if (res.data.code === 0) {
                        this.$Modal.success({
                            title: "提示",
                            content: res.data.message,
                            cancelType: true,
                            titleAlign: "left",
                            mask: true,
                            draggable: true,
                            keyDown: event => {
                                if (event.keyCode == 27 || event.keyCode == 13) {
                                    self.$Modal.remove();
                                }
                            }
                        });
                    } else {
                        this.$Modal.error({
                            title: "提示",
                            content: res.data.message,
                            cancelType: true,
                            titleAlign: "left",
                            mask: true,
                            draggable: true,
                            keyDown: event => {
                                if (event.keyCode == 27 || event.keyCode == 13) {
                                    self.$Modal.remove();
                                }
                            }
                        });
                    }
                });
            },
            cancelBtn() {
                this.copyModal = false;
            },
        }
    };
</script>
<style lang="less">
    .jurisdiction {
        height: 100%;

        .content {
            height: calc(100% - 50px);
            display: flex;
            align-items: center;

            .FilterTree_box {
                height: 100%;

                .FilterTree {
                    height: 100%;
                }
            }

            .right_col {
                height: 100%;
                display: flex;
                width: 100%;
                border: 1px solid #d8d8d8;
                border-radius: 6px;

                .SelectTree_box {
                    height: 100%;
                    display: flex;

                    .SelectTree {
                        height: 100%;
                    }
                }

                .SearchForm_Table {
                    height: 100%;
                    padding: 8px 12px;
                    display: flex;
                    flex: 1;
                    flex-direction: column;

                    .SearchForm {
                        width: 100%;
                    }

                    .table_content {
                        margin-top: 10px;
                    }
                }
            }
        }
    }
</style>
